// src/Components/Utils/TokenRefresh.ts
import axios from "axios";
import jwt_decode from "jwt-decode";

interface DecodedToken {
  exp: number; // UNIX time (seconds)
}

/** Is the token missing or within 5 s of expiry? */
function tokenIsExpired(tok?: string | null) {
  if (!tok) return true;
  const { exp } = jwt_decode<DecodedToken>(tok);
  return exp * 1000 < Date.now() - 5_000;
}

/**
 * Get a valid access-token.
 * – Reads / refreshes localStorage.
 * – **Does NOT use any React hooks.**
 */
export async function getAccessToken(): Promise<string | null> {
  let token: string | null = localStorage.getItem("accessToken") ?? null;

  if (token && !tokenIsExpired(token)) return token;

  const refresh = localStorage.getItem("refreshToken");
  if (!refresh) return null; // must log-in again

  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/refreshToken/refresh`,
      { refreshToken: refresh }
    );

    token = data.accessToken ?? null;

    if (token) localStorage.setItem("accessToken", token);
    else localStorage.removeItem("accessToken");

    if (data.refreshToken)
      localStorage.setItem("refreshToken", data.refreshToken);

    return token;
  } catch (err) {
    console.error("[token] refresh failed → logout", err);
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    window.location.href = "/login?mode=login";
    return null;
  }
}
